import { WIDGET } from './LayoutTypes';

/**
* Traverses down through the tree of layout items to collect all widget
* instances and push them into the 'widgets' parameter.
* @param {object} layoutItems - the layoutItems portion of application state.
* @param {object} item - the top level layout item to traverse down from.
* @param {array} widgets - array where all of the discovered child widgets get pushed into.
*/
export default function getAllChildWidgetsInItem(layoutItems, item, widgets = []) {
  item.layout.childIds.forEach((childId) => {
    if (layoutItems[childId].layout.type === WIDGET) {
      widgets.push(layoutItems[childId]);
    }
    getAllChildWidgetsInItem(layoutItems, layoutItems[childId], widgets);
  });
}
